import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFolder = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 48,
	height: 48,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12.22 24.18A1 1 0 0113.2 23h21.6a1 1 0 01.98 1.18l-1.5 8a1 1 0 01-.98.82H14.7a1 1 0 01-.99-.82l-1.49-8zM15 16a1 1 0 011-1h4.14a1 1 0 01.72.3l1.6 1.68c.2.2.45.3.73.3H32a1 1 0 011 1V22a1 1 0 01-1 1H16a1 1 0 01-1-1v-6z",
		stroke: "#0D47A1",
		fill: "none",
		strokeWidth: 2
	})
});
export default SvgFolder;
